function buildQueryString<P extends Record<string, unknown>>(params: P) {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      const newValue =
        typeof value === "object" ? JSON.stringify(value) : value.toString();

      searchParams.set(key, newValue);
    }
  });

  return {
    queryString:
      searchParams.size > 0
        ? `?${searchParams.toString().replace(/\+/g, "%20")}`
        : "?",
    searchParams,
  };
}

export { buildQueryString };
